import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import InvitationsList from '../components/invitations/InvitationsList'

export default function InvitationsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <InvitationsList />
      </Container>
    </main>
  )
}
